export default __webpack_public_path__ + "static/media/SCIENCE_PSYCHOLOGY_AND_SOCIOLOGY.7ebc4f70.svg";